(function(angular){
	'use strict';
	
	angular
		.module('reitElementListingModule')
		.factory('PropertyService', [
			'$filter',
			'$http',
			'$q',
			'APP_BASE_PATH',
			'Big',
			'urlFactory',
			ReitPropertiesServiceFunction
		]);
	
	function ReitPropertiesServiceFunction(
		$filter,
		$http, 
		$q, 
		APP_BASE_PATH, 
		Big,
		urlFactory) {
		var factory = {
			getPropertyDetail: getPropertyDetail,
			formatPropertyList: formatPropertyList,
			formatPropertyListItem: formatPropertyListItem
		};
		
		return factory;

		function getPropertyDetail(assetId) {
			var deferred = $q.defer();

			$http.get(APP_BASE_PATH + '/reits/asset-tile-details.json?assetId=' + assetId)
				.then(function (response) {
					deferred.resolve(formatPropertyListItem(response.data));
				}).catch(function() {
					deferred.resolve(undefined);
				});

			return deferred.promise;
		}
		
		function formatPropertyList(rawProperties) {
			var properties = {
				active: [],
				redeemed: []
			};

			angular.forEach(rawProperties, function(rawProperty) {
				if (rawProperty.status === 'ACTIVE') {
					properties.active.push(formatPropertyListItem(rawProperty));
				} else if (rawProperty.status === 'REDEEMED') {
					properties.redeemed.push(formatPropertyListItem(rawProperty));
				}
			});

			return properties;
		}

		function getPercentage(floatToConvert) {
			return new Big(floatToConvert).times(new Big(100)).toFixed(1);
		}

		function formatPropertyListItem(rawProperty) {
			rawProperty.coverPhotoUrl = urlFactory.prependStaticUrl(rawProperty.coverPhotoUrl);
			rawProperty.thumbnailUrl = urlFactory.prependStaticUrl(rawProperty.thumbnailUrl);

			if(angular.isDefined(rawProperty.returnRateType)) {
				if(rawProperty.status !== 'REDEEMED') {
					if (rawProperty.returnRateType === 'PROJECTED_RETURN_RANGE') {
						var projectedReturnLowerBoundFormatted = getPercentage(rawProperty.projectedReturnLowerBound);
						var projectedReturnUpperBoundFormatted = getPercentage(rawProperty.projectedReturnUpperBound);
						rawProperty.returnRate = projectedReturnLowerBoundFormatted + ' - ' + projectedReturnUpperBoundFormatted + '%';
						rawProperty.hasProjectedReturnRange = true;
					} else if (rawProperty.returnRateType === 'ANNUAL_INTEREST_RATE') {
						var annualInterestRateFormatted = getPercentage(rawProperty.annualInterestRate);
						rawProperty.returnRate = annualInterestRateFormatted + '%';
						rawProperty.hasProjectedReturnRange = true;
					} else {
						rawProperty.returnRate = '-';
					}
				} else {
					var realizedReturnFormatted = (parseFloat(rawProperty.realizedReturn) * 100).toFixed(1);
					rawProperty.realizedReturn = realizedReturnFormatted + '%';
				}
			}
			return rawProperty;
		}
	}
})(window.angular);